import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import DropdownMain from "../../../../../components/dropdown-main/DropdownMain";
import DisabledPlus from "../../../../../assets/icons/Icon - Add - Disabled.svg";
import { TriyoForm } from "../../../../../components/TriyoForm";
import { NIL as NIL_UUID } from "uuid";
import { WorkflowGridLegacy } from "../grid/workflow-grid-legacy";
import Select from "react-select";
import ReassignWorkflowPermission from "./reassign-workflow-permission";

const EditWorkflowStatusLegacy = ({
  isModelOpen,
  setIsModelOpen,
  openWorkflowStatus,
  workflowStatuses,
  setWorkflowStatuses,
  workflowBaseStatuses,
  setWorkflowBaseStatuses,
  customReminders,
  workflowBasic,
  setWorkflowBasic,
}) => {
  const [availableTime, setAvailableTime] = useState(false);
  const [availableCondition, setAvailableCondition] = useState(false);
  const [hideCondition, setHideCondition] = useState(false);
  const [dueDateExtension, setDueDateExtension] = useState(false);
  const [reminderExtension, setReminderExtension] = useState(false);
  const [availabilityUnits, setAvailabilityUnits] = useState(1);
  const [availabilityPeriod, setAvailabilityPeriod] = useState("Days");
  const [availabilityType, setAvailabilityType] = useState("After Start Date");
  const [availabilityTrigger, setAvailabilityTrigger] = useState("Manual");
  const [selectedWorkflowStatus, setSelectedWorkflowStatus] = useState([]);
  const [selectedIsEnableUndo, setSelectedIsEnableUndo] = useState(false);
  const [
    selectedWorkflowStatusAvailability,
    setSelectedWorkflowStatusAvailability,
  ] = useState([]);
  const availableOptionsAvailability = [
    "Owner",
    "Approvers",
    "Editors",
    "Viewers",
  ];

  const customWorkflowHelpers = {
    AvailabilityTypeValues: [
      { id: "After Start Date", name: "After Start Date" },
      { id: "Before Due Date", name: "Before Due Date" },
    ],
    AvailabilityIntervalTypeValues: [
      { id: "Days", name: "Days" },
      { id: "Business Days", name: "Business Days" },
    ],
  };

  useEffect(() => {
    if (openWorkflowStatus.Id === undefined) {
      return;
    }
    if (
      openWorkflowStatus.AvailableForStatus != null &&
      openWorkflowStatus.AvailableForStatus != NIL_UUID
    ) {
      setAvailableCondition(true);
    }
    if (
      openWorkflowStatus.HideForStatus != null &&
      openWorkflowStatus.HideForStatus != NIL_UUID
    ) {
      setHideCondition(true);
    }
    if (
      openWorkflowStatus.AvailableDaysAfterTaskStart != null &&
      openWorkflowStatus.AvailableDaysAfterTaskStartType != null
    ) {
      setAvailableTime(true);
      setAvailabilityType("After Start Date");
      setAvailabilityPeriod(openWorkflowStatus.AvailableDaysAfterTaskStartType);
    } else if (
      openWorkflowStatus.AvailableDaysBeforeTaskDue != null &&
      openWorkflowStatus.AvailableDaysBeforeTaskDueType != null
    ) {
      setAvailableTime(true);
      setAvailabilityType("Before Due Date");
      setAvailabilityPeriod(openWorkflowStatus.AvailableDaysBeforeTaskDueType);
    }
    if (openWorkflowStatus.DueDateExtensionType != null) {
      setDueDateExtension(true);
    }
    if (
      openWorkflowStatus.ExtendByDaysMax != null &&
      openWorkflowStatus.ExtendByDaysMax > 0
    ) {
      setReminderExtension(true);
    }
    if (
      openWorkflowStatus?.IsInitialStatus ||
      (openWorkflowStatus?.AutomaticTriggers != "" &&
        openWorkflowStatus.AutomaticTriggers != undefined)
    ) {
      setAvailabilityTrigger("Automatic");
    } else {
      setAvailabilityTrigger("Manual");
    }
    if (openWorkflowStatus.AutomaticTriggers == undefined) {
      openWorkflowStatus.AutomaticTriggers = "";
    }
    if (openWorkflowStatus?.Name === "Re-assign Task") {
      openWorkflowStatus.SelectedOwnerPermissions = JSON.parse(
        openWorkflowStatus?.PermissionConditions
      )?.Owner;
      openWorkflowStatus.SelectedApproverPermissions = JSON.parse(
        openWorkflowStatus?.PermissionConditions
      )?.Approvers;
      openWorkflowStatus.SelectedEditorPermissions = JSON.parse(
        openWorkflowStatus?.PermissionConditions
      )?.Editors;
      openWorkflowStatus.SelectedViewerPermissions = JSON.parse(
        openWorkflowStatus?.PermissionConditions
      )?.Viewers;
    }
    if (openWorkflowStatus.IsEnableUndo === false) {
      setSelectedIsEnableUndo(false);
    } else {
      setSelectedIsEnableUndo(true);
    }
    setSelectedWorkflowStatus(openWorkflowStatus);
    setSelectedWorkflowStatusAvailability(openWorkflowStatus.IsAvailableToList);
    setIsModelOpen(true);
  }, [openWorkflowStatus]);

  const handleClose = () => {
    setSelectedWorkflowStatus({});
    setIsModelOpen(false);
    setAvailableTime(false);
    setAvailableCondition(false);
    setHideCondition(false);
    setDueDateExtension(false);
    setReminderExtension(false);
    setSelectedIsEnableUndo(false);
    setAvailabilityTrigger("Manual");
    setSelectedWorkflowStatusAvailability([]);
  };

  const addUpdateCurrentWorkflowStatus = () => {
    let workflowStatusesTemp = selectedWorkflowStatus.IsBase
      ? workflowBaseStatuses
      : workflowStatuses;
    selectedWorkflowStatus.IsAvailableToList =
      selectedWorkflowStatusAvailability;
    let index = workflowStatusesTemp.findIndex(
      (x) => x.Id === selectedWorkflowStatus.Id
    );
    if (index > -1) {
      workflowStatusesTemp[index] = selectedWorkflowStatus;
    } else {
      workflowStatusesTemp.push(selectedWorkflowStatus);
    }
    if (
      selectedWorkflowStatus?.AutomaticTriggers.includes("Task Creation") &&
      !selectedWorkflowStatus?.IsInitialStatus
    ) {
      selectedWorkflowStatus.AutomaticTriggers =
        selectedWorkflowStatus?.AutomaticTriggers?.split(",")
          .filter((trigger) => trigger != "Task Creation")
          .join(",");
      selectedWorkflowStatus.IsInitialStatus = true;
      workflowStatusesTemp = workflowStatusesTemp.map((status) => {
        if (status.Id == selectedWorkflowStatus.Id) {
          return selectedWorkflowStatus;
        } else {
          return { ...status, IsInitialStatus: false };
        }
      });
      if (selectedWorkflowStatus?.IsBase) {
        setWorkflowStatuses(
          workflowStatuses.map((status) => {
            return { ...status, IsInitialStatus: false };
          })
        );
      } else {
        setWorkflowBaseStatuses(
          workflowBaseStatuses.map((status) => {
            return { ...status, IsInitialStatus: false };
          })
        );
      }
      setWorkflowBasic({
        ...workflowBasic,
        InitialStatus: {
          id: selectedWorkflowStatus.Name,
          name: selectedWorkflowStatus.Name,
          isBase: selectedWorkflowStatus.IsBase,
        },
      });
    }
    if (selectedWorkflowStatus.IsBase) {
      setWorkflowBaseStatuses(workflowStatusesTemp);
    } else {
      setWorkflowStatuses(workflowStatusesTemp);
    }
    handleClose();
  };

  const setReassignPermissionConditions = (data) => {
    data.PermissionConditions = JSON.stringify({
      Owner: data.SelectedOwnerPermissions,
      Approvers: data.SelectedApproverPermissions,
      Editors: data.SelectedEditorPermissions,
      Viewers: data.SelectedViewerPermissions,
    });
    setSelectedWorkflowStatus(data);
  };

  return (
    <Modal
      show={isModelOpen}
      className="workflow-modal-panel"
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Task Action</Modal.Title>
      </Modal.Header>

      <Modal.Body className="workflow-modal-body">
        {/* STATUS NAME */}
        <div className="workflow-modal-section">
          <img src={DisabledPlus}></img>
          <Form.Control
            type="text"
            value={selectedWorkflowStatus?.Name}
            onChange={(e) => {
              setSelectedWorkflowStatus({
                ...selectedWorkflowStatus,
                Name: e.target.value,
              });
            }}
            placeholder="Enter task action name"
            disabled={selectedWorkflowStatus?.IsBase}
          />
        </div>
        <hr className="divider"></hr>

        {/* STATUS DESCRIPTION */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Description</div>
            <div className="workflow-modal-description-subtitle">
              The description for the customized task action
            </div>
          </div>
          <div className="workflow-modal-input">
            <Form>
              <Form.Group className="description">
                <Form.Control
                  id="description"
                  name="description"
                  autoComplete="off"
                  placeholder="Describe how people should use this task"
                  className="project-textarea textarea"
                  value={selectedWorkflowStatus?.Description}
                  onChange={(e) => {
                    setSelectedWorkflowStatus({
                      ...selectedWorkflowStatus,
                      Description: e.target.value,
                    });
                  }}
                  as="textarea"
                  rows="3"
                  disabled={selectedWorkflowStatus?.IsBase}
                />
              </Form.Group>
            </Form>
          </div>
        </div>
        <hr className="divider"></hr>

        {/* MAX INSTANCES */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Frequency</div>
            <div className="workflow-modal-description-subtitle">
              The number of times this task action will be used in the work
              flow. Set 0 for no limit.
            </div>
          </div>
          <div className="workflow-modal-input">
            <Form.Control
              type="number"
              value={selectedWorkflowStatus?.MaxInstances}
              onChange={(e) => {
                setSelectedWorkflowStatus({
                  ...selectedWorkflowStatus,
                  MaxInstances: e.target.value,
                });
              }}
              placeholder=""
              disabled={selectedWorkflowStatus?.IsBase}
            />
          </div>
        </div>
        <hr className="divider"></hr>

        {/* AVAILABILITY */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Availability</div>
            <div className="workflow-modal-description-subtitle">
              Configure when the task action will be available in the task
              action menu.
            </div>
          </div>
          <div className="workflow-modal-input">
            <div>
              <div className="workflow-modal-description-title">
                This Task Action is triggered
              </div>
              <label className="workflow-radio">
                <input
                  className={"filter-panel-dropdown-members-radio-button"}
                  type="radio"
                  checked={availabilityTrigger == "Manual"}
                  onChange={() => {
                    setSelectedWorkflowStatus({
                      ...selectedWorkflowStatus,
                      Active: false,
                      AutomaticTriggers: "",
                    });
                    setAvailabilityTrigger("Manual");
                  }}
                  disabled={selectedWorkflowStatus?.IsInitialStatus}
                />
                Manually
              </label>
              <label className="workflow-radio">
                <input
                  className={"filter-panel-dropdown-members-radio-button"}
                  type="radio"
                  checked={availabilityTrigger == "Automatic"}
                  onChange={() => {
                    setSelectedWorkflowStatus({
                      ...selectedWorkflowStatus,
                      Active: true,
                    });
                    setAvailabilityTrigger("Automatic");
                  }}
                  disabled={
                    selectedWorkflowStatus?.IsBase &&
                    selectedWorkflowStatus?.Name == "Re-assign Task"
                  }
                />
                Automatically
              </label>
            </div>
            {availabilityTrigger == "Manual" ? (
              <div>
                <div className="greyText mb-4">
                  When a Task Action is set to be to be triggered Manually,
                  Assigned Members for the Task will be able to select it from
                  the Actions Overflow menu to apply the associated Automations.
                </div>
                <div className="available-section">
                  {/* AVAILABLE TIME  */}
                  <div className="available-time">
                    <div className="workflow-modal-description">
                      <div className="workflow-modal-description-title">
                        Set Available Time
                      </div>
                      <div className="workflow-modal-description-subtitle">
                        Enabling this toggle will allow you to set the available
                        time for this task action.
                      </div>
                    </div>

                    <TriyoForm.Toggle
                      checked={availableTime}
                      onChange={() => {
                        if (!availableTime) {
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            AvailableDaysAfterTaskStart: 1,
                            AvailableDaysAfterTaskStartType: "Days",
                          });
                          setAvailabilityPeriod("Days");
                          setAvailabilityType("After Start Date");
                          setAvailabilityUnits(1);
                        } else {
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            AvailableDaysBeforeTaskDue: null,
                            AvailableDaysBeforeTaskDueType: null,
                            AvailableDaysAfterTaskStart: null,
                            AvailableDaysAfterTaskStartType: null,
                          });
                        }
                        setAvailableTime(!availableTime);
                      }}
                    />
                  </div>
                  {availableTime && (
                    <div className="available-time-options">
                      <div className="availabilityUnits">
                        <input
                          value={
                            selectedWorkflowStatus?.AvailableDaysAfterTaskStart ??
                            selectedWorkflowStatus?.AvailableDaysBeforeTaskDue
                          }
                          type="number"
                          min={1}
                          required
                          onKeyDown={(e) => {
                            (e.key === "Enter" ||
                              e.key === "." ||
                              e.key === "-") &&
                              e.preventDefault();
                          }}
                          onBlur={(e) => {
                            if (e.target.value == 0) {
                              e.target.value = 1;
                            }
                          }}
                          onChange={(e) => {
                            e.target.value =
                              e.target.value == 0 ? 1 : e.target.value;
                            if (availabilityType == "After Start Date") {
                              setSelectedWorkflowStatus({
                                ...selectedWorkflowStatus,
                                AvailableDaysAfterTaskStart: e.target.value,
                                AvailableDaysBeforeTaskDue: null,
                              });
                            } else {
                              setSelectedWorkflowStatus({
                                ...selectedWorkflowStatus,
                                AvailableDaysBeforeTaskDue: e.target.value,
                                AvailableDaysAfterTaskStart: null,
                              });
                            }
                            setAvailabilityUnits(e.target.value);
                          }}
                        />
                      </div>
                      <div className="availabilityPeriod">
                        <div className="row-dropdown">
                          <DropdownMain
                            values={
                              customWorkflowHelpers.AvailabilityIntervalTypeValues
                            }
                            dropdownButtonText={"-Select-"}
                            onSelect={(selectedValue) => {
                              if (availabilityType == "After Start Date") {
                                setSelectedWorkflowStatus({
                                  ...selectedWorkflowStatus,
                                  AvailableDaysAfterTaskStartType:
                                    selectedValue.name,
                                });
                              } else {
                                setSelectedWorkflowStatus({
                                  ...selectedWorkflowStatus,
                                  AvailableDaysBeforeTaskDueType:
                                    selectedValue.name,
                                });
                              }
                              setAvailabilityPeriod(selectedValue.name);
                            }}
                            currentSelected={{ name: availabilityPeriod }}
                            additonalClasses={
                              "overflowSetAbsolute dropdown-custom-reminders"
                            }
                            alignRight={true}
                          />
                        </div>
                      </div>
                      <td className="availabilityType">
                        <div className="reminder-dropdown">
                          <DropdownMain
                            values={
                              customWorkflowHelpers.AvailabilityTypeValues
                            }
                            dropdownButtonText={"-Select-"}
                            onSelect={(selectedValue) => {
                              if (availabilityType != selectedValue.name) {
                                if (selectedValue.name == "After Start Date") {
                                  setSelectedWorkflowStatus({
                                    ...selectedWorkflowStatus,
                                    AvailableDaysAfterTaskStartType:
                                      availabilityPeriod,
                                    AvailableDaysAfterTaskStart:
                                      availabilityUnits,
                                  });
                                } else {
                                  setSelectedWorkflowStatus({
                                    ...selectedWorkflowStatus,
                                    AvailableDaysBeforeTaskDueType:
                                      availabilityPeriod,
                                    AvailableDaysBeforeTaskDue:
                                      availabilityUnits,
                                  });
                                }
                              }
                              setAvailabilityType(selectedValue.name);
                            }}
                            currentSelected={{ name: availabilityType }}
                            additonalClasses={"overflowSetAbsolute"}
                            alignRight={true}
                          />
                        </div>
                      </td>
                    </div>
                  )}

                  {/* AVAILABLE CONDITION */}
                  <div className="available-time">
                    <div className="workflow-modal-description">
                      <div className="workflow-modal-description-title">
                        Set Available Condition
                      </div>
                      <div className="workflow-modal-description-subtitle">
                        Enabling this toggle will allow you to set the available
                        condition for this task action. The task action will
                        only be available for the selected task status.
                      </div>
                    </div>

                    <TriyoForm.Toggle
                      onChange={() => {
                        if (availableCondition) {
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            AvailableForStatus: NIL_UUID,
                          });
                        }
                        setAvailableCondition(!availableCondition);
                      }}
                      checked={availableCondition}
                    />
                  </div>
                  {availableCondition && (
                    <div className="available-time-options">
                      <DropdownMain
                        values={
                          workflowStatuses &&
                          workflowStatuses
                            .filter((options) => {
                              if (options.Id !== selectedWorkflowStatus?.Id)
                                return options;
                            })
                            .map((options) => {
                              return { id: options.Id, name: options.Name };
                            })
                        }
                        dropdownButtonText={"Select an existing task status"}
                        onSelect={(selectedValue) => {
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            AvailableForStatus: selectedValue.id,
                          });
                        }}
                        currentSelected={
                          selectedWorkflowStatus?.AvailableForStatus != NIL_UUID
                            ? { id: selectedWorkflowStatus?.AvailableForStatus }
                            : null
                        }
                      />
                    </div>
                  )}

                  {/* UNAVAILABLE CONDITION */}
                  <div className="available-time">
                    <div className="workflow-modal-description">
                      <div className="workflow-modal-description-title">
                        Set Unavailable Condition
                      </div>
                      <div className="workflow-modal-description-subtitle">
                        Enabling this toggle will allow you to set the
                        unavailable condition for this task action. The task
                        action will not be available for the selected task
                        status.
                      </div>
                    </div>

                    <TriyoForm.Toggle
                      onChange={() => {
                        if (hideCondition) {
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            HideForStatus: NIL_UUID,
                          });
                        }
                        setHideCondition(!hideCondition);
                      }}
                      checked={hideCondition}
                    />
                  </div>
                  {hideCondition && (
                    <div className="available-time-options">
                      <DropdownMain
                        values={
                          workflowStatuses &&
                          workflowStatuses
                            .filter((options) => {
                              if (options.Id !== selectedWorkflowStatus?.Id)
                                return options;
                            })
                            .map((options) => {
                              return { id: options.Id, name: options.Name };
                            })
                        }
                        dropdownButtonText={"Select an existing task status"}
                        onSelect={(selectedValue) => {
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            HideForStatus: selectedValue.id,
                          });
                        }}
                        currentSelected={
                          selectedWorkflowStatus?.HideForStatus != NIL_UUID
                            ? { id: selectedWorkflowStatus?.HideForStatus }
                            : null
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <div className="greyText mb-4">
                  When a Task Action is set to be triggered Automatically, this
                  Task Action and associated Automations will be applied when
                  certain events occur during the Task Workflow. Please select
                  what events trigger this Task Action from the list below.
                </div>
                <div>
                  <TriyoForm.Checkboxes
                    className="availabilityCheckBoxes"
                    lookupValues={[
                      "Task Creation",
                      "Task Updates",
                      "Internal Email Responses",
                      "External Email Responses",
                      "Task Comments",
                      "Re-Assigned",
                    ]}
                    value={selectedWorkflowStatus?.AutomaticTriggers}
                    onChange={(e) => {
                      setSelectedWorkflowStatus({
                        ...selectedWorkflowStatus,
                        AutomaticTriggers: e,
                      });
                    }}
                    disabledChecked={
                      selectedWorkflowStatus?.IsInitialStatus
                        ? "Task Creation"
                        : ""
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <hr className="divider"></hr>

        {/* PERMISSIONS */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Permission</div>
          </div>
          <div className="workflow-modal-input">
            <div className="workflow-modal-description-title mb-3">
              Select who has access to this task action
            </div>
            <Select
              isMulti
              options={availableOptionsAvailability.map((value) => ({
                value,
                label: value,
              }))}
              value={
                selectedWorkflowStatusAvailability != null &&
                selectedWorkflowStatusAvailability.map((status) => ({
                  value: status,
                  label: status,
                }))
              }
              onChange={(selected) =>
                setSelectedWorkflowStatusAvailability(
                  selected ? selected.map((option) => option.value) : []
                )
              }
              placeholder="Select workflow roles"
            />
            <div className="mb-3"></div>
            {!(selectedWorkflowStatus?.IsSelfAssign ||
              selectedWorkflowStatus?.IsBase) && (
              <div>
                <div className="workflow-modal-description-title ">
                  Enable Undo
                </div>
                <label className="workflow-radio">
                  <input
                    className={"filter-panel-dropdown-members-radio-button"}
                    type="radio"
                    checked={selectedWorkflowStatus?.IsEnableUndo}
                    onChange={() => {
                      setSelectedWorkflowStatus({
                        ...selectedWorkflowStatus,
                        IsEnableUndo: true,
                      });
                    }}
                  />
                  Yes
                </label>
                <label className="workflow-radio">
                  <input
                    className={"filter-panel-dropdown-members-radio-button"}
                    type="radio"
                    checked={!selectedWorkflowStatus?.IsEnableUndo}
                    onChange={() => {
                      setSelectedWorkflowStatus({
                        ...selectedWorkflowStatus,
                        IsEnableUndo: false,
                      });
                    }}
                  />
                  No
                </label>
              </div>
            )}
          </div>
        </div>
        <hr className="divider"></hr>

        {/* AUTOMATION  */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Automation</div>
            <div className="workflow-modal-description-subtitle">
              Configure events that will be triggered by the task action.
            </div>
          </div>
          <div className="workflow-modal-input ">
            {/* PROJECT COMPLETE */}
            <div>
              <div className="workflow-modal-description-title mb-3">
                What task status will this task action lead to?
              </div>
              <div>
                <Form>
                  <Form.Group className="description">
                    <Form.Control
                      type="text"
                      id="actionstatus"
                      name="actionstatus"
                      autoComplete="off"
                      placeholder="The name of the action status displayed in the Status column of the task list."
                      value={selectedWorkflowStatus?.ActionStatus}
                      onChange={(e) => {
                        setSelectedWorkflowStatus({
                          ...selectedWorkflowStatus,
                          ActionStatus: e.target.value,
                        });
                      }}
                      disabled={selectedWorkflowStatus?.IsBase}
                    />
                  </Form.Group>
                </Form>
              </div>
              <div className="workflow-modal-description-title">
                Will the task be completed after this task action?
              </div>
              <label className="workflow-radio">
                <input
                  className={"filter-panel-dropdown-members-radio-button"}
                  type="radio"
                  checked={!selectedWorkflowStatus?.Active}
                  onChange={() => {
                    setSelectedWorkflowStatus({
                      ...selectedWorkflowStatus,
                      Active: false,
                    });
                  }}
                  disabled={selectedWorkflowStatus?.IsBase}
                />
                Yes
              </label>
              <label className="workflow-radio">
                <input
                  className={"filter-panel-dropdown-members-radio-button"}
                  type="radio"
                  checked={selectedWorkflowStatus?.Active}
                  onChange={() => {
                    setSelectedWorkflowStatus({
                      ...selectedWorkflowStatus,
                      Active: true,
                    });
                  }}
                  disabled={selectedWorkflowStatus?.IsBase}
                />
                No
              </label>
            </div>
            {/* DUE DATE EXTENSION  */}
            <div className="available-section">
              <div className="available-time">
                <div className="workflow-modal-description">
                  <div className="workflow-modal-description-title">
                    Enable Task Due Date Extension
                  </div>
                  <div className="workflow-modal-description-subtitle">
                    Enabling this toggle will give you the option to extend the
                    task due date when performing this task action.
                  </div>
                </div>

                <TriyoForm.Toggle
                  onChange={() => {
                    if (dueDateExtension) {
                      setSelectedWorkflowStatus({
                        ...selectedWorkflowStatus,
                        DueDateExtensionDefault: null,
                        DueDateExtensionType: null,
                        DueDateExtendProject: null,
                        DueDateExtension: null,
                      });
                    } else {
                      setSelectedWorkflowStatus({
                        ...selectedWorkflowStatus,
                        DueDateExtensionDefault: 1,
                        DueDateExtensionType: "Days",
                        DueDateExtendProject: true,
                        DueDateExtension: true,
                      });
                    }
                    setDueDateExtension(!dueDateExtension);
                  }}
                  checked={dueDateExtension}
                  disabled={selectedWorkflowStatus?.IsBase}
                />
              </div>
              {dueDateExtension && (
                <div className="extension">
                  <div className="extension-text">
                    Extend the Task Due Date by
                  </div>
                  <div className="available-time-options">
                    <div className="availabilityUnits dueDateExtension">
                      <input
                        value={
                          selectedWorkflowStatus?.DueDateExtensionDefault == 0
                            ? 1
                            : selectedWorkflowStatus?.DueDateExtensionDefault
                        }
                        type="number"
                        min={1}
                        required
                        onKeyDown={(e) => {
                          (e.key === "Enter" ||
                            e.key === "." ||
                            e.key === "-") &&
                            e.preventDefault();
                        }}
                        onBlur={(e) => {
                          if (e.target.value == 0) {
                            e.target.value = 1;
                          }
                        }}
                        onChange={(e) => {
                          e.target.value =
                            e.target.value == 0 ? 1 : e.target.value;
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            DueDateExtensionDefault: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="availabilityPeriod dueDateExtension">
                      <div className="row-dropdown">
                        <DropdownMain
                          values={
                            customWorkflowHelpers.AvailabilityIntervalTypeValues
                          }
                          dropdownButtonText={"-Select-"}
                          onSelect={(selectedValue) => {
                            setSelectedWorkflowStatus({
                              ...selectedWorkflowStatus,
                              DueDateExtensionType: selectedValue.name,
                            });
                          }}
                          currentSelected={
                            selectedWorkflowStatus?.DueDateExtensionType == null
                              ? { name: "Days" }
                              : {
                                  name: selectedWorkflowStatus?.DueDateExtensionType,
                                }
                          }
                          additonalClasses={
                            "overflowSetAbsolute dropdown-custom-reminders"
                          }
                          alignRight={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="workflow-project-extend">
                    <span>
                      What would you like to happen to the Project Due Date?
                    </span>
                    <div className="workflow-radio">
                      <input
                        className={"filter-panel-dropdown-members-radio-button"}
                        type="radio"
                        checked={selectedWorkflowStatus?.DueDateExtendProject}
                        onChange={() => {
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            DueDateExtendProject: true,
                          });
                        }}
                      />
                      Also extend project due date
                    </div>
                    <div className="workflow-radio">
                      <input
                        className={"filter-panel-dropdown-members-radio-button"}
                        type="radio"
                        checked={!selectedWorkflowStatus?.DueDateExtendProject}
                        onChange={() => {
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            DueDateExtendProject: false,
                          });
                        }}
                      />
                      Do not extend project due date
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* REMNINDER EXTENSION  */}
            <div className="available-section">
              <div className="available-time">
                <div className="workflow-modal-description">
                  <div className="workflow-modal-description-title">
                    Enable Task Reminder Extension
                  </div>
                  <div className="workflow-modal-description-subtitle">
                    Enabling this toggle will give you the option to extend a
                    task reminder when performing this task action.
                  </div>
                </div>

                <TriyoForm.Toggle
                  onChange={() => {
                    if (reminderExtension) {
                      setSelectedWorkflowStatus({
                        ...selectedWorkflowStatus,
                        ExtendByDaysMax: null,
                        ExtendReminderName: null,
                      });
                    } else {
                      setSelectedWorkflowStatus({
                        ...selectedWorkflowStatus,
                        ExtendByDaysMax: 1,
                      });
                    }
                    setReminderExtension(!reminderExtension);
                  }}
                  checked={reminderExtension}
                  disabled={selectedWorkflowStatus?.IsBase}
                />
              </div>
              {reminderExtension && (
                <div className="extension">
                  <div className="available-time-options-headings">
                    <div className="availabilityUnits extension-text">
                      Max Business Days the Reminder can be Extended by
                    </div>
                    <div className="availabilityUnits extension-text">
                      Reminder Name
                    </div>
                  </div>
                  <div className="available-time-options">
                    <div className="availabilityUnits dueDateExtension">
                      <input
                        value={
                          selectedWorkflowStatus?.ExtendByDaysMax == 0
                            ? 1
                            : selectedWorkflowStatus?.ExtendByDaysMax
                        }
                        type="number"
                        min={1}
                        required
                        onKeyDown={(e) => {
                          (e.key === "Enter" ||
                            e.key === "." ||
                            e.key === "-") &&
                            e.preventDefault();
                        }}
                        onBlur={(e) => {
                          if (e.target.value == 0) {
                            e.target.value = 1;
                          }
                        }}
                        onChange={(e) => {
                          e.target.value =
                            e.target.value == 0 ? 1 : e.target.value;
                          setSelectedWorkflowStatus({
                            ...selectedWorkflowStatus,
                            ExtendByDaysMax: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <DropdownMain
                      values={
                        customReminders &&
                        customReminders.map((options) => {
                          return { id: options.Name, name: options.Name };
                        })
                      }
                      dropdownButtonText={"Select a custom task reminder"}
                      onSelect={(selectedValue) => {
                        setSelectedWorkflowStatus({
                          ...selectedWorkflowStatus,
                          ExtendReminderName: selectedValue.id,
                        });
                      }}
                      currentSelected={
                        selectedWorkflowStatus?.ExtendReminderName != null
                          ? { id: selectedWorkflowStatus?.ExtendReminderName }
                          : null
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <hr className="divider"></hr>

        {/* CONDITIONS  */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Custom Rules</div>
            <div className="workflow-modal-description-subtitle">
              Configure specific conditions.
            </div>
          </div>
          <div className="workflow-modal-input ">
            {selectedWorkflowStatus?.Name == "Re-assign Task" &&
            selectedWorkflowStatus?.IsBase ? (
              <ReassignWorkflowPermission
                data={selectedWorkflowStatus}
                setData={setReassignPermissionConditions}
                availableOptionsAvailability={availableOptionsAvailability}
              />
            ) : (
              <div>
                <WorkflowGridLegacy
                  workflowStatusId={selectedWorkflowStatus.Id}
                  type={"form-visibility"}
                  name={"Form Conditions (Available)"}
                />
                <hr />
                <WorkflowGridLegacy
                  workflowStatusId={selectedWorkflowStatus.Id}
                  type={"form-availability"}
                  name={"Form Conditions (Hidden)"}
                />
                <hr />
                <WorkflowGridLegacy
                  workflowStatusId={selectedWorkflowStatus.Id}
                  type={"field"}
                  name={"Field Conditions"}
                />
              </div>
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn btn-setting-light btn-sm" onClick={handleClose}>
          Close
        </Button>
        <Button
          className="btn btn-setting-primary btn-sm"
          onClick={addUpdateCurrentWorkflowStatus}
        >
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditWorkflowStatusLegacy;
